// extracted by mini-css-extract-plugin
export default {"badge":"Badge_badge__NCatq","highlight":"Badge_highlight__q1CIf","success":"Badge_success__gIk3w","deep":"Badge_deep__q7TJq","circle":"Badge_circle__QEEs-"};